import { render, staticRenderFns } from "./NewCarrierVisitAdd.vue?vue&type=template&id=1771163e&scoped=true&"
import script from "./NewCarrierVisitAdd.vue?vue&type=script&lang=js&"
export * from "./NewCarrierVisitAdd.vue?vue&type=script&lang=js&"
import style0 from "./NewCarrierVisitAdd.vue?vue&type=style&index=0&id=1771163e&lang=scss&scoped=true&"
import style1 from "./NewCarrierVisitAdd.vue?vue&type=style&index=1&id=1771163e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1771163e",
  null
  
)

export default component.exports